import { combineReducers } from 'redux';

import Auth from './Auth';
import Banners from './Banners';
import Contracts from './Contracts';
import Communicated from './Communicated';
import System from './System';
import FavoriteApps from './FavoriteApps';
import TableauAuth from './TableauAuth';

const appReducer = combineReducers({
  auth: Auth,
  system: System,
  banners: Banners,
  contracts: Contracts,
  communicated: Communicated,
  apps: FavoriteApps,
  tableau: TableauAuth,
});

export default (state, action) => {
  if (action.type === 'clear_persisted_data') {
    state = undefined;
  }
  return appReducer(state, action);
};
